import {ALGO_ASSET_ID} from "@tinymanorg/tinyman-js-sdk";

import {USDC_ASSET} from "../../asset/util/assetConstants";
import {getAssetId} from "../../asset/util/assetUtils";

const DEFAULT_SWAP_ASSET_IDS = {
  IN: ALGO_ASSET_ID,
  OUT: getAssetId(USDC_ASSET)
};

export {DEFAULT_SWAP_ASSET_IDS};
